import React from "react";
import { IMAGES } from "@/i18n/content";

// Official VORNX gold logo on transparent background — renders cleanly on any section.
export const Logo = ({ variant = "mark", className = "" }) => (
  <img
    src={variant === "full" ? IMAGES.logoFull : IMAGES.logoMark}
    alt="VORNX — Home Fragrance"
    draggable={false}
    loading="eager"
    decoding="async"
    className={`select-none object-contain ${className}`}
  />
);
